import BookShow from "components/shared/book/show";
import { viewContainer } from "helpers/redux";
import React from "react";
import { config, initialState } from "../formConfig";
import Markup from "./markup";

class ShowTransportColumn extends BookShow {
    getItem = ({ source, match }) => {
        const defParams = { isLoading: false, isValid: true, shouldUpdate: false };
        source.getItem(match.params).then((data) => this.setState({ data, initial: data, ...defParams }));
    };

    get dropdActions() {
        const { canEditBooks } = this.props;
        return canEditBooks ? [{ text: "Удалить", action: this.actionClose }] : [];
    }

    renderBody = () => {
        const { config } = this.props;
        return <Markup {...config} renderField={this.renderField} Button={this.renderButton} />;
    };
}

const ConfiguredShow = (props) => <ShowTransportColumn {...props} config={config} initialState={initialState} />;

export default viewContainer(ConfiguredShow, "transportcolumns");
